import { useStats } from '../../../lib/ctx/stats'
import { useStatsPermission, useStatsZeroState } from '../../../lib/hooks'
import { ReaderInsight } from '../../shared/ReaderInsight'
import { StatsProfileBox } from '../../shared/stats_profile_box'
import pluralize from 'pluralize'
import { MomBooksContent } from './MomBooksContent'
import { analytics } from 'segment_analytics'

export const MomBooks = () => {
  const [yearStatus, year, stats] = useStats((s) => [
    s.yearStatus,
    s.year,
    s.stats,
  ])
  const insight = stats?.mom_books_read?.insight || ''
  const zeroState = useStatsZeroState('mom-books-read')
  const { isStatsOwner } = useStatsPermission()
  const booksRead = stats?.mom_books_read?.total_count || 0
  const isPastYear = yearStatus === 'past'
  const id = 'monthly-books'

  const getFooter = () => {
    if (!isStatsOwner) return null

    if (zeroState && yearStatus === 'current') {
      return (
        <ReaderInsight
          data-testid={`reader-insight-${id}`}
          label="How to get started"
          text="Add books to your Finished list, and make sure to mark that you
finished it this year."
        />
      )
    }

    if (!isPastYear && !!insight?.length) {
      return (
        <ReaderInsight data-testid={`stats-insight-${id}`} text={insight} />
      )
    }

    return null
  }

  return (
    <StatsProfileBox
      id={id}
      data-testid={`stats-${id}`}
      text={{
        top: 'Finished',
        main: booksRead.toString(),
        unit: pluralize('book', booksRead),
        infoText: (
          <>
            <b>Missing a book?</b>
            <br />
            Check your Finished list to verify the book has a {year} finished
            date.
            <br />
            <br />
            <b>Need to remove a book?</b>
            <br />
            Remove the book’s {year} finished date in your Finished list. If the
            book isn’t in your Finished list but is showing up in your {year}{' '}
            stats, re-add the book to your Finished list in order to remove its
            read date(s).
          </>
        ),
      }}
      footer={getFooter()}
      screenshot={{
        enabled: !zeroState,
        component: <MomBooksContent skipAnim />,
        onClick: () =>
          analytics.events.stats.statsShareTap({ type: 'monthly_books' }),
      }}
    >
      {zeroState ? null : <MomBooksContent />}
    </StatsProfileBox>
  )
}
